export function formatIdentifier(value: string | null | undefined): string {
    if (value === null || value === undefined) return "";
    if (value.length === 9) return `${value.substring(0, 3)} ${value.substring(3, 6)} ${value.substring(6, 9)}`;
    return value;
}